export default "__VITE_ASSET__BIhcjvNG__"